// ES5 version without any external dependencies
(function() {
    'use strict';
    
    const WIDGET_MESSAGE_RESIZE = 'resize';
    const WIDGET_MESSAGE_SENDER = 'jw_widget';
    
    let contentHeight = 0;
    let resizeTimeout = null;
    
    // Simple debounce implementation
    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                func.apply(context, args);
            }, wait);
        };
    }
    
    function sendHeight(newContentHeight) {
        var previewElement = document.getElementById('justwatchPreview');
        
        console.log('SEND HEIGHT', previewElement);
        
        if (!previewElement) {
            return;
        }
        
        if (newContentHeight === undefined) {
            newContentHeight = Math.round(previewElement.getBoundingClientRect().height);
        }
        
        if (newContentHeight === contentHeight) {
            return;
        }
        
        contentHeight = newContentHeight;
        
        var parents = [
            window.parent && window.parent.parent && window.parent.parent.parent,
            window.parent && window.parent.parent,
            window.parent
        ].filter(function(parent) {
            return parent !== null && parent !== undefined;
        });
        
        console.log('contentHeight: ', contentHeight);
        
        for (var i = 0; i < parents.length; i++) {
            var parent = parents[i];
            if (parent && parent.postMessage) {
                parent.postMessage({
                    type: WIDGET_MESSAGE_RESIZE,
                    sender: WIDGET_MESSAGE_SENDER,
                    cssHeight: contentHeight + 'px'
                }, "*");
            }
        }
    }
    
    var handleResize = debounce(function() {
        sendHeight();
    }, 50);
    
    function handleMessage(event) {
        if (
            event.data &&
            event.data.type === WIDGET_MESSAGE_RESIZE &&
            event.data.sender === WIDGET_MESSAGE_SENDER
        ) {
            var height = parseInt(event.data.cssHeight, 10);
            sendHeight(height);
        }
    }
    
    // Check if DOM is already loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleResize);
    } else {
        // DOM already loaded, call immediately
        handleResize();
    }
    
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);
    window.addEventListener("message", handleMessage);
    
    // Initial send
    sendHeight();
})();